import { a5 as store_get, a6 as attr, a4 as ensure_array_like, a8 as unsubscribe_stores, P as pop, N as push } from "../../../../../../chunks/index.js";
import { p as page } from "../../../../../../chunks/stores.js";
import { D as DownloadButton } from "../../../../../../chunks/DownloadButton.js";
import celebrating from "../../../../../../chunks/flexy-happy-young-man-celebrating-something.js";
import { L as Link } from "../../../../../../chunks/Link.js";
import "../../../../../../chunks/analytics.js";
const error = {
  sources: {
    avif: "/_app/immutable/assets/error.MCIdgFH7.avif 1370w, /_app/immutable/assets/error.BE64pmnL.avif 2739w",
    webp: "/_app/immutable/assets/error.CmQRaf9N.webp 1370w, /_app/immutable/assets/error.ffd5-l7N.webp 2739w",
    png: "/_app/immutable/assets/error.BnpmgSQy.png 1370w, /_app/immutable/assets/error.Dh5BG-FY.png 2739w"
  },
  img: {
    src: "/_app/immutable/assets/error.Dh5BG-FY.png",
    w: 2739,
    h: 3974
  }
};
function _page($$payload, $$props) {
  push();
  var $$store_subs;
  $$payload.out += `<div class="section-container"><div class="section text-center flex items-center justify-center min-h-screen">`;
  if (store_get($$store_subs ??= {}, "$page", page).data.checkout.success) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div class="flex flex-col items-center max-w-screen-md"><img${attr("src", celebrating)}${attr("width", 256)} alt="Person celebrating"> <div class="font-bold font-display text-5xl capitalize mt-8 text-teal-900">Thank you for your purchase!</div> <div class="font-display opacity-70 text-xl mt-4">You should receive an email shortly with your license information. In the
					meantime, download Glimmr by clicking the button below.</div> `;
    DownloadButton($$payload, { class: "mt-12", size: 2 });
    $$payload.out += `<!----></div>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<div class="flex flex-col items-center max-w-screen-md">`;
    if (typeof error === "string") {
      $$payload.out += "<!--[-->";
      $$payload.out += `<img${attr("src", error.img.src)} width="148" height="NaN">`;
    } else {
      $$payload.out += "<!--[!-->";
      const each_array = ensure_array_like(Object.entries(error.sources));
      $$payload.out += `<picture><!--[-->`;
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let [format, srcset] = each_array[$$index];
        $$payload.out += `<source${attr("srcset", srcset)}${attr("type", "image/" + format)}>`;
      }
      $$payload.out += `<!--]--> <img${attr("src", error.img.src)} width="148" height="NaN"></picture>`;
    }
    $$payload.out += `<!--]--> <div class="font-bold font-display text-5xl capitalize mt-8 text-teal-900">Woops.</div> <div class="font-display opacity-70 text-xl mt-4">There was an error processing your order. Please try again or contact us at <span class="inline-block text-teal-600">`;
    Link($$payload, {
      to: "mailto:support@glimmr.app",
      children: ($$payload2) => {
        $$payload2.out += `<!---->support@glimmr.app`;
      },
      $$slots: { default: true }
    });
    $$payload.out += `<!----></span></div></div>`;
  }
  $$payload.out += `<!--]--></div></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
export {
  _page as default
};
